/**
 * All accepted item availability values per https://schema.org/ItemAvailability
 */
export const ItemAvailability = Object.freeze({
  BACK_ORDER: 'BackOrder',
  DISCONTINUED: 'Discontinued',
  IN_STOCK: 'InStock',
  IN_STORE_ONLY: 'InStoreOnly',
  LIMITED_AVAILABILITY: 'LimitedAvailability',
  ONLINE_ONLY: 'OnlineOnly',
  OUT_OF_STOCK: 'OutOfStock',
  PRE_ORDER: 'PreOrder',
  PRE_SALE: 'PreSale',
  SOLD_OUT: 'SoldOut',
});

export const StockStatusEnums = Object.freeze({
  EnumGlobalStockStatus1: 'EnumGlobalStockStatus1', // In Stock
  EnumGlobalStockStatus3: 'EnumGlobalStockStatus3', // In Stores Only
  EnumGlobalStockStatus4: 'EnumGlobalStockStatus4', // Out of Stock
  EnumGlobalStockStatus5: 'EnumGlobalStockStatus5', // Coming Soon
  EnumGlobalStockStatus6: 'EnumGlobalStockStatus6', // In Warehouse
  EnumGlobalStockStatus7: 'EnumGlobalStockStatus7', // Contact Retailer
  EnumGlobalStockStatus8: 'EnumGlobalStockStatus8', // Build to Order
  EnumGlobalStockStatus9: 'EnumGlobalStockStatus9', // BTO in Stock
});

export const StockStatusMap = Object.freeze({
  [StockStatusEnums.EnumGlobalStockStatus1]: ItemAvailability.IN_STOCK,
  [StockStatusEnums.EnumGlobalStockStatus3]: ItemAvailability.IN_STORE_ONLY,
  [StockStatusEnums.EnumGlobalStockStatus4]: ItemAvailability.OUT_OF_STOCK,
  [StockStatusEnums.EnumGlobalStockStatus5]: ItemAvailability.PRE_SALE,
  [StockStatusEnums.EnumGlobalStockStatus6]: ItemAvailability.IN_STOCK,
  [StockStatusEnums.EnumGlobalStockStatus7]: ItemAvailability.BACK_ORDER,
  [StockStatusEnums.EnumGlobalStockStatus8]: ItemAvailability.BACK_ORDER,
  [StockStatusEnums.EnumGlobalStockStatus9]: ItemAvailability.IN_STOCK,
});
